import type { PTZ } from '@studio/models/ptz';

/** Movement handler. */
export type Handler = (intent: PTZ) => void;

/** Facet-specific rate. */
export type Rate = Readonly<{
  /** Custom speed indicator. */
  custom: boolean;

  /** Preset pace. */
  pace: Pace;

  /** Actual speed. */
  value: Speed;
}>;

/** Movement speed. */
export type Speed = number;

/** Pipeline transform. */
export type Transform = Transformer | TransformFn;

/** Transformation object. */
export interface Transformer {
  /** Transformation function. */
  transform: TransformFn;
}

/** Transformation function. */
export type TransformFn = (
  ptz: PTZ
) => // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
PTZ | void;

/** Ramp direction. */
export enum Direction {
  Down = 'down',
  Up = 'up'
}

/** Control facet. */
export enum Facet {
  PanTilt = 'pan/tilt',
  TrackingSpeed = 'tracking/speed',
  Zoom = 'zoom'
}

/** Movement pace. */
export enum Pace {
  Fast = 'fast',
  Medium = 'medium',
  Slow = 'slow'
}

/** Speed tempo. */
export enum Tempo {
  Fixed = 'fixed',
  Variable = 'variable'
}
